import { useContext, useEffect, useRef } from "react";
import Message from "./Message";
import { AppContext } from './Context/Context.jsx';
import axios from "axios";
import { API_URL, TOKEN } from "./Constants/constants";
import api from "./Constants/Refresh.jsx";

function Messages({ messages, setMessages, chatbotSocket, setTyping, typing }) {
    const messagesEndRef = useRef(null);
    const { handleSendChat, chatId } = useContext(AppContext);

    useEffect(() => {
        if (!chatbotSocket) return; // socket hali mavjud bo‘lmasa chiqib ket

        const handleMessage = async (event) => {
            try {
                const data = JSON.parse(event.data);

                if (data.answer?.length > 0) {
                    setTyping(false);

                    const activeChatId = chatId || localStorage.getItem("chatId");
                    const newMessage = { content: data.answer, owner: "assistant" };
                    setMessages((prev) => [...prev, newMessage]);

                    if (activeChatId && activeChatId !== "0") {
                        await axios.post(`${API_URL}/chats/messages/post`, {
                            owner: "assistant",
                            content: data.answer,
                            chat_id: activeChatId
                        }, {
                            headers: { Authorization: `Bearer ${TOKEN}` },
                        }).catch(err => console.log("Bot xabarini saqlashda xato:", err));
                    }

                    setTimeout(() => {
                        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
                    }, 100);
                }
            } catch (err) {
                console.error("Botdan kelgan xabarni parse qilishda xatolik:", err);
            }
        };

        chatbotSocket.addEventListener("message", handleMessage);

        return () => chatbotSocket.removeEventListener("message", handleMessage);
    }, [chatId, chatbotSocket, setMessages, setTyping]);




    return (
        <div ref={messagesEndRef} className="chat-area-main">
            <Message typing={typing} messages={messages} messagesEndRef={messagesEndRef} />
            {typing && (
                <p className="typing">
                    Yozmoqda<span className="dot dot1">.</span>
                    <span className="dot dot2">.</span>
                    <span className="dot dot3">.</span>
                </p>
            )}
        </div>
    );
}

export default Messages;
